import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArrowUp, faCaretDown, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useRouter } from "vue-router/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InstanceDropdown',
    props: {
        prefix: null,
        name: null,
        routeEdit: null,
        routeUpgrade: null,
        isUpgradable: { type: Boolean }
    },
    emits: ["remove"],
    setup(__props, { emit }) {
        library.add(faArrowUp, faCaretDown, faEdit, faTrash);
        const router = useRouter();
        return { __sfc: true, router, emit, faArrowUp, FontAwesomeIcon };
    }
});
